import http from 'conversations-http/clients/http';
export const getChatflow = ({
  chatflowId
}) => http.get(`chatflows/v2/channel-instance/chatflow/${chatflowId}`);